const prodBaseURL = "https://app.abn.live/api/";
const stagingBaseURL = "https://staging.abn.live/api/";
const baseURL = window.location.host === "abn-pwa-staging.herokuapp.com" ? stagingBaseURL : prodBaseURL;
export default baseURL;
